import { render, staticRenderFns } from "./DepartmentCreate.vue?vue&type=template&id=0e46f972"
import script from "./DepartmentCreate.vue?vue&type=script&lang=js"
export * from "./DepartmentCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports